import React, { useState } from 'react'
import Modal from "react-responsive-modal";
import { SingleDatePicker } from 'react-dates';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Select from "react-select";
import app from '../../../../libs/apiClient';
const service = app.service("api/expenseTicket");
import moment from 'moment';

export const DownloadModal = ({ showModal, handleCloseModal, type, options }) => {

    const [focused, setFocused] = useState(false);
    const [focused2, setFocused2] = useState(false);
    const [formValues, setFormValues] = useState({
        startDate: null,
        endDate: null,
        type: null
    });

    const handleChange = (name, value) => {
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const start = formValues.startDate.format('YYYY-MM-DD')
        const end = formValues.endDate.format('YYYY-MM-DD')
        const is4tolls = type === 'tolls' && options.find(item => item.value === 'Toll Expenses')

        try {

            const query = {
                startDate: start,
                endDate: end,
            };

            if (is4tolls) {
                query.type = is4tolls.id;
            } else if (formValues.type) {
                query.type = formValues.type;
            }

            const result = await service.find({ query });

            if (type === 'compensation') {

                const wb = XLSX.utils.book_new();
                wb.Props = {
                    Title: `driver_conpensation_report_${start}_${end}`,
                    Subject: "Tickets",
                    Author: "BBC Express",
                    CreatedDate: new Date(),
                };

                const ws_data = [
                    [
                        "Compensation Type",
                        "Driver Name",
                        "Vehicle Name",
                        "Trip Type",
                        "Total Hours",
                        "Date",
                        "Additional Details",
                        "Created By",
                        "Create Date",
                        "Livery Id"
                    ]
                ];

                result.forEach(ticket => {
                    ws_data.push([
                        (ticket.expense_type_id && ticket.expense_type_id.name) || '',
                        ticket.driver_name || '',
                        ticket.vehicle_name || '',
                        ticket.trip_type || '',
                        ticket.total_hours != null ? ticket.total_hours.toFixed(2) : '',
                        ticket.start_datetime || '',
                        ticket.po_field || '',
                        ticket.created_by || '',
                        moment(ticket.createdAt).format('YYYY-MM-DD HH:mm') || '',
                        ticket.livery_id || ''
                    ]);
                });

                const ws = XLSX.utils.aoa_to_sheet(ws_data);
                const headerStyle = {
                    font: { bold: true },
                    alignment: { horizontal: 'center' }
                };

                const columnsCount = 10; // Número de columnas
                for (let col = 0; col < columnsCount; col++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                    ws[cellAddress].s = headerStyle;
                }

                const wscols = Array(columnsCount).fill({ wch: 20 });
                ws['!cols'] = wscols;

                XLSX.utils.book_append_sheet(wb, ws, 'expense-tickets');

                const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

                const s2ab = (s) => {
                    const buf = new ArrayBuffer(s.length);
                    const view = new Uint8Array(buf);
                    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                };

                saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), `driver_conpensation_report_${start}_${end}.xlsx`);

            } else {
                const formartData = result.map(item => ({
                    'Driver Name': item.driver_name || '',
                    'Username': item.driver_LiveryId || '',
                    'Vehicle Name': item.vehicle_name || '',
                    'Date': item.start_datetime || '',
                    'Reason': item.reason || '',
                    'Is Approved': item.is_approved || '',
                    'Notes': item.notes || ''
                }))
                const ws = XLSX.utils.json_to_sheet(formartData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Report");
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                saveAs(excelBlob, `toll_usage_report_${start}_${end}.xlsx`);
            }

            handleCloseModal()
        } catch (error) {
            console.log(error)
            handleCloseModal()
        }
    }


    return (
        <Modal
            open={showModal}
            onClose={handleCloseModal}
            showCloseIcon={false}
            classNames={{ modal: "modal-sm" }}
            blockScroll={false}
        >
            <div className="d-flex flex-column">
                <div className="mb-2">
                    <label>Start Date</label>
                    <div className='form-control p-1'>
                        <SingleDatePicker
                            id="date_input"
                            date={formValues.startDate}
                            onDateChange={(newDate) => handleChange('startDate', newDate)}
                            focused={focused}
                            onFocusChange={({ focused }) => setFocused(focused)}
                            numberOfMonths={1}
                            isOutsideRange={() => false}
                            placeholder='2025-01-01'
                        />
                    </div>
                </div>
                <div className="mb-2">
                    <label>End Date</label>
                    <div className='form-control p-1'>
                        <SingleDatePicker
                            id="date_input2"
                            date={formValues.endDate}
                            onDateChange={(newDate) => handleChange('endDate', newDate)}
                            focused={focused2}
                            onFocusChange={({ focused }) => setFocused2(focused)}
                            numberOfMonths={1}
                            isOutsideRange={(day) =>
                                formValues.startDate ? day.isBefore(formValues.startDate, 'day') : false
                            }
                            placeholder='2025-01-02'
                        />
                    </div>
                </div>

                {type === 'compensation' && (
                    <div className="mb-2">
                        <label>Expense Type</label>
                        <Select
                            options={options}
                            value={options.find((option) => option.id === formValues.type) || null}
                            onChange={(option) => handleChange('type', option ? option.id : null)}
                            placeholder="Incident type"
                            clearable
                        />
                    </div>
                )}

                <div className="d-flex flex-row mt-4 justify-content-between">
                    <button
                        className="btn btn-secondary"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleSubmit}
                    >
                        Download
                    </button>
                </div>
            </div>
        </Modal>
    )
}
